"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

require("intersection-observer");

var _reactIntersectionObserver = require("react-intersection-observer");

var _Card = _interopRequireDefault(require("../Card"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _useTheme3 = _interopRequireDefault(require("../styles/useTheme"));

var _Contract = _interopRequireDefault(require("./Contract"));

var _Description = _interopRequireDefault(require("./Description"));

var _Header = _interopRequireDefault(require("./Header"));

var _Hours = _interopRequireDefault(require("./Hours"));

var _LoadingProvider = _interopRequireDefault(require("./LoadingProvider"));

var _Main = _interopRequireDefault(require("./Main"));

var _Skills = _interopRequireDefault(require("./Skills"));

var _StaticMap = _interopRequireDefault(require("./StaticMap"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles(contentMaxWidth) {
  var _firstColumn;

  var _useTheme = (0, _useTheme3["default"])(),
      breakpoint = _useTheme.breakpoint,
      spacing = _useTheme.spacing;

  var mobileMediaQuery = breakpoint.down('md');
  var tabletMediaQuery = breakpoint.up('md');
  var desktopMediaQuery = breakpoint.up('lg');
  return {
    root: (0, _defineProperty2["default"])({
      flexDirection: 'column'
    }, tabletMediaQuery, {
      alignItems: 'center'
    }),
    body: (0, _defineProperty2["default"])({
      flexDirection: 'column',
      width: '100%',
      maxWidth: contentMaxWidth
    }, tabletMediaQuery, {
      marginTop: spacing(2.5),
      flexDirection: 'row',
      padding: spacing(0, 2),
      boxSizing: 'border-box'
    }),
    firstColumn: (_firstColumn = {
      flexDirection: 'column',
      width: '100%'
    }, (0, _defineProperty2["default"])(_firstColumn, tabletMediaQuery, {
      width: spacing(53.3),
      marginRight: spacing(2),
      flex: '0 0 auto'
    }), (0, _defineProperty2["default"])(_firstColumn, desktopMediaQuery, {
      width: spacing(62.5)
    }), _firstColumn),
    secondColumn: (0, _defineProperty2["default"])({
      flexDirection: 'column'
    }, tabletMediaQuery, {
      flex: '1 1 auto'
    }),
    card: {
      marginBottom: spacing(2)
    },
    // on mobile we want to merge this header with
    // the first card of the body content
    // so make it white and above this first card
    headerContainer: (0, _defineProperty2["default"])({
      flexDirection: 'row',
      zIndex: 1,
      backgroundColor: 'white'
    }, tabletMediaQuery, {
      width: '100%',
      margin: 0,
      borderRadius: '1rem',
      backgroundColor: 'transparent',
      zIndex: 0
    }),
    mainCard: (0, _defineProperty2["default"])({}, mobileMediaQuery, {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    }),
    main: (0, _defineProperty2["default"])({
      margin: spacing(0, 2)
    }, mobileMediaQuery, {
      margin: spacing(0, 2, 2)
    })
  };
};

__signature__(useStyles, "useTheme{{ breakpoint, spacing }}", function () {
  return [_useTheme3["default"]];
});

var ResponsiveJobCard = function ResponsiveJobCard(props) {
  var _useTheme2 = (0, _useTheme3["default"])(),
      breakpoint = _useTheme2.breakpoint;

  var loading = props.loading,
      jobId = props.jobId,
      updateDate = props.updateDate,
      jobLabel = props.jobLabel,
      cityName = props.cityName,
      postalCode = props.postalCode,
      grossHourlyRate = props.grossHourlyRate,
      grossHourlyRateIncludingCP = props.grossHourlyRateIncludingCP,
      startDate = props.startDate,
      endDate = props.endDate,
      weeklyHours = props.weeklyHours,
      _props$certificationL = props.certificationLicences,
      certificationLicences = _props$certificationL === void 0 ? [] : _props$certificationL,
      _props$languageSkills = props.languageSkills,
      languageSkills = _props$languageSkills === void 0 ? [] : _props$languageSkills,
      _props$computerSkills = props.computerSkills,
      computerSkills = _props$computerSkills === void 0 ? [] : _props$computerSkills,
      jobStatus = props.jobStatus,
      timeTables = props.timeTables,
      tasks = props.tasks,
      profile = props.profile,
      googleMapsApiKey = props.googleMapsApiKey,
      latitude = props.latitude,
      longitude = props.longitude,
      radius = props.radius,
      onSalaryClick = props.onSalaryClick,
      advertisement = props.advertisement,
      _props$contentMaxWidt = props.contentMaxWidth,
      contentMaxWidth = _props$contentMaxWidt === void 0 ? breakpoint.values.lg : _props$contentMaxWidt,
      other = (0, _objectWithoutProperties2["default"])(props, ["loading", "jobId", "updateDate", "jobLabel", "cityName", "postalCode", "grossHourlyRate", "grossHourlyRateIncludingCP", "startDate", "endDate", "weeklyHours", "certificationLicences", "languageSkills", "computerSkills", "jobStatus", "timeTables", "tasks", "profile", "googleMapsApiKey", "latitude", "longitude", "radius", "onSalaryClick", "advertisement", "contentMaxWidth"]);
  var styles = useStyles(contentMaxWidth);

  var _useInView = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true
  }),
      _useInView2 = (0, _slicedToArray2["default"])(_useInView, 2),
      refObserver = _useInView2[0],
      isMapInView = _useInView2[1];

  var displaySkills = !loading && (languageSkills.length > 0 || computerSkills.length > 0 || certificationLicences.length > 0);
  return (0, _core.jsx)(_LoadingProvider["default"], {
    loading: loading
  }, (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    css: styles.root
  }, other), (0, _core.jsx)(_Flex["default"], {
    css: styles.headerContainer
  }, (0, _core.jsx)(_Header["default"], {
    jobId: jobId,
    updateDate: updateDate,
    jobLabel: jobLabel,
    grossHourlyRate: grossHourlyRate,
    grossHourlyRateIncludingCP: grossHourlyRateIncludingCP,
    onSalaryClick: onSalaryClick
  })), (0, _core.jsx)(_Flex["default"], {
    css: styles.body
  }, (0, _core.jsx)(_Flex["default"], {
    css: styles.firstColumn
  }, (0, _core.jsx)(_Card["default"], {
    css: /*#__PURE__*/(0, _css2["default"])(_objectSpread({}, styles.mainCard, {}, styles.card), ";label:ResponsiveJobCard;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0xrQiIsImZpbGUiOiIuLi8uLi9zcmMvUmVzcG9uc2l2ZUpvYkNhcmQvaW5kZXgudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IEZ1bmN0aW9uQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBDU1NPYmplY3QgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuaW1wb3J0ICdpbnRlcnNlY3Rpb24tb2JzZXJ2ZXInO1xuaW1wb3J0IHsgdXNlSW5WaWV3IH0gZnJvbSAncmVhY3QtaW50ZXJzZWN0aW9uLW9ic2VydmVyJztcblxuaW1wb3J0IENhcmQgZnJvbSAnLi4vQ2FyZCc7XG5pbXBvcnQgRmxleCwgeyBGbGV4UHJvcHMgfSBmcm9tICcuLi9GbGV4JztcbmltcG9ydCB1c2VUaGVtZSBmcm9tICcuLi9zdHlsZXMvdXNlVGhlbWUnO1xuaW1wb3J0IENvbnRyYWN0IGZyb20gJy4vQ29udHJhY3QnO1xuaW1wb3J0IERlc2NyaXB0aW9uIGZyb20gJy4vRGVzY3JpcHRpb24nO1xuaW1wb3J0IEhlYWRlciBmcm9tICcuL0hlYWRlcic7XG5pbXBvcnQgSG91cnMgZnJvbSAnLi9Ib3Vycyc7XG5pbXBvcnQgeyBUaW1lVGFibGUgfSBmcm9tICcuL0hvdXJzL0hvdXJseUN5Y2xlL3VzZVRpbWVUYWJsZXMnO1xuaW1wb3J0IExvYWRpbmdQcm92aWRlciBmcm9tICcuL0xvYWRpbmdQcm92aWRlcic7XG5pbXBvcnQgTWFpbiBmcm9tICcuL01haW4nO1xuaW1wb3J0IFNraWxscyBmcm9tICcuL1NraWxscyc7XG5pbXBvcnQgeyBMYW5ndWFnZVNraWxsIH0gZnJvbSAnLi9Ta2lsbHMvTGFuZ3VhZ2VTa2lsbHMnO1xuaW1wb3J0IFN0YXRpY01hcCBmcm9tICcuL1N0YXRpY01hcCc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgUmVzcG9uc2l2ZUpvYkNhcmRQcm9wcyBleHRlbmRzIEZsZXhQcm9wczwnZGl2Jz4ge1xuICBsb2FkaW5nPzogYm9vbGVhbjtcbiAgam9iSWQ/OiBzdHJpbmc7XG4gIG9uU2FsYXJ5Q2xpY2s/OiAoKSA9PiB2b2lkO1xuICB1cGRhdGVEYXRlPzogc3RyaW5nIHwgbnVtYmVyO1xuICBqb2JMYWJlbD86IHN0cmluZztcbiAgY2l0eU5hbWU/OiBzdHJpbmc7XG4gIHBvc3RhbENvZGU/OiBzdHJpbmc7XG4gIGdyb3NzSG91cmx5UmF0ZT86IG51bWJlcjtcbiAgZ3Jvc3NIb3VybHlSYXRlSW5jbHVkaW5nQ1A/OiBudW1iZXI7XG4gIHN0YXJ0RGF0ZT86IHN0cmluZyB8IG51bWJlcjtcbiAgZW5kRGF0ZT86IHN0cmluZyB8IG51bWJlcjtcbiAgd2Vla2x5SG91cnM/OiBudW1iZXI7XG4gIGNlcnRpZmljYXRpb25MaWNlbmNlcz86IHN0cmluZ1tdO1xuICBsYW5ndWFnZVNraWxscz86IExhbmd1YWdlU2tpbGxbXTtcbiAgY29tcHV0ZXJTa2lsbHM/OiB7IHZhbHVlPzogc3RyaW5nIH1bXTtcbiAgam9iU3RhdHVzPzogc3RyaW5nO1xuICB0aW1lVGFibGVzPzogVGltZVRhYmxlW107XG4gIHRhc2tzPzogc3RyaW5nO1xuICBwcm9maWxlPzogc3RyaW5nO1xuICBnb29nbGVNYXBzQXBpS2V5Pzogc3RyaW5nO1xuICBsYXRpdHVkZT86IG51bWJlcjtcbiAgbG9uZ2l0dWRlPzogbnVtYmVyO1xuICByYWRpdXM/OiBudW1iZXI7XG4gIGFkdmVydGlzZW1lbnQ/OiBzdHJpbmc7XG4gIGNvbnRlbnRNYXhXaWR0aD86IENTU09iamVjdFsnbWF4V2lkdGgnXTtcbn1cblxuY29uc3QgdXNlU3R5bGVzID0gKGNvbnRlbnRNYXhXaWR0aDogQ1NTT2JqZWN0WydtYXhXaWR0aCddKSA9PiB7XG4gIGNvbnN0IHsgYnJlYWtwb2ludCwgc3BhY2luZyB9ID0gdXNlVGhlbWUoKTtcblxuICBjb25zdCBtb2JpbGVNZWRpYVF1ZXJ5ID0gYnJlYWtwb2ludC5kb3duKCdtZCcpO1xuICBjb25zdCB0YWJsZXRNZWRpYVF1ZXJ5ID0gYnJlYWtwb2ludC51cCgnbWQnKTtcbiAgY29uc3QgZGVza3RvcE1lZGlhUXVlcnkgPSBicmVha3BvaW50LnVwKCdsZycpO1xuXG4gIHJldHVybiB7XG4gICAgcm9vdDoge1xuICAgICAgZmxleERpcmVjdGlvbjogJ2NvbHVtbicsXG4gICAgICBbdGFibGV0TWVkaWFRdWVyeV06IHtcbiAgICAgICAgYWxpZ25JdGVtczogJ2NlbnRlcicsXG4gICAgICB9LFxuICAgIH0sXG4gICAgYm9keToge1xuICAgICAgZmxleERpcmVjdGlvbjogJ2NvbHVtbicsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgICAgbWF4V2lkdGg6IGNvbnRlbnRNYXhXaWR0aCxcbiAgICAgIFt0YWJsZXRNZWRpYVF1ZXJ5XToge1xuICAgICAgICBtYXJnaW5Ub3A6IHNwYWNpbmcoMi41KSxcbiAgICAgICAgZmxleERpcmVjdGlvbjogJ3JvdycsXG4gICAgICAgIHBhZGRpbmc6IHNwYWNpbmcoMCwgMiksXG4gICAgICAgIGJveFNpemluZzogJ2JvcmRlci1ib3gnLFxuICAgICAgfSxcbiAgICB9LFxuICAgIGZpcnN0Q29sdW1uOiB7XG4gICAgICBmbGV4RGlyZWN0aW9uOiAnY29sdW1uJyxcbiAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgICBbdGFibGV0TWVkaWFRdWVyeV06IHtcbiAgICAgICAgd2lkdGg6IHNwYWNpbmcoNTMuMyksXG4gICAgICAgIG1hcmdpblJpZ2h0OiBzcGFjaW5nKDIpLFxuICAgICAgICBmbGV4OiAnMCAwIGF1dG8nLFxuICAgICAgfSxcbiAgICAgIFtkZXNrdG9wTWVkaWFRdWVyeV06IHtcbiAgICAgICAgd2lkdGg6IHNwYWNpbmcoNjIuNSksXG4gICAgICB9LFxuICAgIH0sXG4gICAgc2Vjb25kQ29sdW1uOiB7XG4gICAgICBmbGV4RGlyZWN0aW9uOiAnY29sdW1uJyxcbiAgICAgIFt0YWJsZXRNZWRpYVF1ZXJ5XToge1xuICAgICAgICBmbGV4OiAnMSAxIGF1dG8nLFxuICAgICAgfSxcbiAgICB9LFxuXG4gICAgY2FyZDoge1xuICAgICAgbWFyZ2luQm90dG9tOiBzcGFjaW5nKDIpLFxuICAgIH0sXG5cbiAgICAvLyBvbiBtb2JpbGUgd2Ugd2FudCB0byBtZXJnZSB0aGlzIGhlYWRlciB3aXRoXG4gICAgLy8gdGhlIGZpcnN0IGNhcmQgb2YgdGhlIGJvZHkgY29udGVudFxuICAgIC8vIHNvIG1ha2UgaXQgd2hpdGUgYW5kIGFib3ZlIHRoaXMgZmlyc3QgY2FyZFxuICAgIGhlYWRlckNvbnRhaW5lcjoge1xuICAgICAgZmxleERpcmVjdGlvbjogJ3JvdycsXG4gICAgICB6SW5kZXg6IDEsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6ICd3aGl0ZScsXG4gICAgICBbdGFibGV0TWVkaWFRdWVyeV06IHtcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgbWFyZ2luOiAwLFxuICAgICAgICBib3JkZXJSYWRpdXM6ICcxcmVtJyxcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICB6SW5kZXg6IDAsXG4gICAgICB9LFxuICAgIH0sXG4gICAgbWFpbkNhcmQ6IHtcbiAgICAgIC8vIGRlbGV0ZSBib3JkZXIgcmFkaXVzIHRvIG1lcmdlIHRoZSBjYXJkIHdpdGggdGhlIGhlYWRlclxuICAgICAgW21vYmlsZU1lZGlhUXVlcnldOiB7XG4gICAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IDAsXG4gICAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiAwLFxuICAgICAgfSxcbiAgICB9LFxuICAgIG1haW46IHtcbiAgICAgIG1hcmdpbjogc3BhY2luZygwLCAyKSxcbiAgICAgIFttb2JpbGVNZWRpYVF1ZXJ5XToge1xuICAgICAgICBtYXJnaW46IHNwYWNpbmcoMCwgMiwgMiksXG4gICAgICB9LFxuICAgIH0sXG4gIH0gYXMgY29uc3Q7XG59O1xuXG5jb25zdCBSZXNwb25zaXZlSm9iQ2FyZDogRnVuY3Rpb25Db21wb25lbnQ8UmVzcG9uc2l2ZUpvYkNhcmRQcm9wcz4gPSAocHJvcHMpID0+IHtcbiAgY29uc3QgeyBicmVha3BvaW50IH0gPSB1c2VUaGVtZSgpO1xuXG4gIGNvbnN0IHtcbiAgICBsb2FkaW5nLFxuICAgIGpvYklkLFxuICAgIHVwZGF0ZURhdGUsXG4gICAgam9iTGFiZWwsXG4gICAgY2l0eU5hbWUsXG4gICAgcG9zdGFsQ29kZSxcbiAgICBncm9zc0hvdXJseVJhdGUsXG4gICAgZ3Jvc3NIb3VybHlSYXRlSW5jbHVkaW5nQ1AsXG4gICAgc3RhcnREYXRlLFxuICAgIGVuZERhdGUsXG4gICAgd2Vla2x5SG91cnMsXG4gICAgY2VydGlmaWNhdGlvbkxpY2VuY2VzID0gW10sXG4gICAgbGFuZ3VhZ2VTa2lsbHMgPSBbXSxcbiAgICBjb21wdXRlclNraWxscyA9IFtdLFxuICAgIGpvYlN0YXR1cyxcbiAgICB0aW1lVGFibGVzLFxuICAgIHRhc2tzLFxuICAgIHByb2ZpbGUsXG4gICAgZ29vZ2xlTWFwc0FwaUtleSxcbiAgICBsYXRpdHVkZSxcbiAgICBsb25naXR1ZGUsXG4gICAgcmFkaXVzLFxuICAgIG9uU2FsYXJ5Q2xpY2ssXG4gICAgYWR2ZXJ0aXNlbWVudCxcbiAgICBjb250ZW50TWF4V2lkdGggPSBicmVha3BvaW50LnZhbHVlcy5sZyxcbiAgICAuLi5vdGhlclxuICB9ID0gcHJvcHM7XG5cbiAgY29uc3Qgc3R5bGVzID0gdXNlU3R5bGVzKGNvbnRlbnRNYXhXaWR0aCk7XG5cbiAgY29uc3QgW3JlZk9ic2VydmVyLCBpc01hcEluVmlld10gPSB1c2VJblZpZXcoe1xuICAgIHRyaWdnZXJPbmNlOiB0cnVlLFxuICB9KTtcblxuICBjb25zdCBkaXNwbGF5U2tpbGxzID1cbiAgICAhbG9hZGluZyAmJiAobGFuZ3VhZ2VTa2lsbHMubGVuZ3RoID4gMCB8fCBjb21wdXRlclNraWxscy5sZW5ndGggPiAwIHx8IGNlcnRpZmljYXRpb25MaWNlbmNlcy5sZW5ndGggPiAwKTtcblxuICByZXR1cm4gKFxuICAgIDxMb2FkaW5nUHJvdmlkZXIgbG9hZGluZz17bG9hZGluZ30+XG4gICAgICA8RmxleCBjc3M9e3N0eWxlcy5yb290fSB7Li4ub3RoZXJ9PlxuICAgICAgICA8RmxleCBjc3M9e3N0eWxlcy5oZWFkZXJDb250YWluZXJ9PlxuICAgICAgICAgIDxIZWFkZXJcbiAgICAgICAgICAgIGpvYklkPXtqb2JJZH1cbiAgICAgICAgICAgIHVwZGF0ZURhdGU9e3VwZGF0ZURhdGV9XG4gICAgICAgICAgICBqb2JMYWJlbD17am9iTGFiZWx9XG4gICAgICAgICAgICBncm9zc0hvdXJseVJhdGU9e2dyb3NzSG91cmx5UmF0ZX1cbiAgICAgICAgICAgIGdyb3NzSG91cmx5UmF0ZUluY2x1ZGluZ0NQPXtncm9zc0hvdXJseVJhdGVJbmNsdWRpbmdDUH1cbiAgICAgICAgICAgIG9uU2FsYXJ5Q2xpY2s9e29uU2FsYXJ5Q2xpY2t9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9GbGV4PlxuICAgICAgICA8RmxleCBjc3M9e3N0eWxlcy5ib2R5fT5cbiAgICAgICAgICA8RmxleCBjc3M9e3N0eWxlcy5maXJzdENvbHVtbn0+XG4gICAgICAgICAgICA8Q2FyZCBjc3M9e3sgLi4uc3R5bGVzLm1haW5DYXJkLCAuLi5zdHlsZXMuY2FyZCB9fSBjb2xvcj1cIndoaXRlXCI+XG4gICAgICAgICAgICAgIDxNYWluXG4gICAgICAgICAgICAgICAgY2l0eU5hbWU9e2NpdHlOYW1lfVxuICAgICAgICAgICAgICAgIHBvc3RhbENvZGU9e3Bvc3RhbENvZGV9XG4gICAgICAgICAgICAgICAgc3RhcnREYXRlPXtzdGFydERhdGV9XG4gICAgICAgICAgICAgICAgZW5kRGF0ZT17ZW5kRGF0ZX1cbiAgICAgICAgICAgICAgICB3ZWVrbHlIb3Vycz17d2Vla2x5SG91cnN9XG4gICAgICAgICAgICAgICAgY3NzPXtzdHlsZXMubWFpbn1cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvQ2FyZD5cbiAgICAgICAgICAgIHtkaXNwbGF5U2tpbGxzICYmIChcbiAgICAgICAgICAgICAgPENhcmQgY3NzPXtzdHlsZXMuY2FyZH0gY29sb3I9XCJ3aGl0ZVwiPlxuICAgICAgICAgICAgICAgIDxTa2lsbHNcbiAgICAgICAgICAgICAgICAgIGNlcnRpZmljYXRpb25MaWNlbmNlcz17Y2VydGlmaWNhdGlvbkxpY2VuY2VzfVxuICAgICAgICAgICAgICAgICAgbGFuZ3VhZ2VTa2lsbHM9e2xhbmd1YWdlU2tpbGxzfVxuICAgICAgICAgICAgICAgICAgY29tcHV0ZXJTa2lsbHM9e2NvbXB1dGVyU2tpbGxzfVxuICAgICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgIDwvQ2FyZD5cbiAgICAgICAgICAgICl9XG4gICAgICAgICAgICA8Q2FyZCBjc3M9e3N0eWxlcy5jYXJkfSBjb2xvcj1cIndoaXRlXCI+XG4gICAgICAgICAgICAgIDxIb3VycyB0aW1lVGFibGVzPXt0aW1lVGFibGVzfSAvPlxuICAgICAgICAgICAgPC9DYXJkPlxuICAgICAgICAgICAgPENhcmQgY3NzPXtzdHlsZXMuY2FyZH0gY29sb3I9XCJ3aGl0ZVwiIHJlZj17cmVmT2JzZXJ2ZXJ9PlxuICAgICAgICAgICAgICB7aXNNYXBJblZpZXcgPyAoXG4gICAgICAgICAgICAgICAgPFN0YXRpY01hcFxuICAgICAgICAgICAgICAgICAgZ29vZ2xlTWFwc0FwaUtleT17Z29vZ2xlTWFwc0FwaUtleX1cbiAgICAgICAgICAgICAgICAgIGxhdGl0dWRlPXtsYXRpdHVkZX1cbiAgICAgICAgICAgICAgICAgIGxvbmdpdHVkZT17bG9uZ2l0dWRlfVxuICAgICAgICAgICAgICAgICAgcmFkaXVzPXtyYWRpdXN9XG4gICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgKSA6IG51bGx9XG4gICAgICAgICAgICA8L0NhcmQ+XG4gICAgICAgICAgPC9GbGV4PlxuICAgICAgICAgIDxGbGV4IGNzcz17c3R5bGVzLnNlY29uZENvbHVtbn0+XG4gICAgICAgICAgICA8Q2FyZCBjc3M9e3N0eWxlcy5jYXJkfSBjb2xvcj1cIndoaXRlXCI+XG4gICAgICAgICAgICAgIDxEZXNjcmlwdGlvbiB0YXNrcz17dGFza3N9IHByb2ZpbGU9e3Byb2ZpbGV9IGFkdmVydGlzZW1lbnQ9e2FkdmVydGlzZW1lbnR9IC8+XG4gICAgICAgICAgICA8L0NhcmQ+XG4gICAgICAgICAgICA8Q2FyZCBjc3M9e3N0eWxlcy5jYXJkfSBjb2xvcj1cIndoaXRlXCI+XG4gICAgICAgICAgICAgIDxDb250cmFjdCBqb2JTdGF0dXM9e2pvYlN0YXR1c30gLz5cbiAgICAgICAgICAgIDwvQ2FyZD5cbiAgICAgICAgICA8L0ZsZXg+XG4gICAgICAgIDwvRmxleD5cbiAgICAgIDwvRmxleD5cbiAgICA8L0xvYWRpbmdQcm92aWRlcj5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFJlc3BvbnNpdmVKb2JDYXJkO1xuIl19 */")),
    color: "white"
  }, (0, _core.jsx)(_Main["default"], {
    cityName: cityName,
    postalCode: postalCode,
    startDate: startDate,
    endDate: endDate,
    weeklyHours: weeklyHours,
    css: styles.main
  })), displaySkills && (0, _core.jsx)(_Card["default"], {
    css: styles.card,
    color: "white"
  }, (0, _core.jsx)(_Skills["default"], {
    certificationLicences: certificationLicences,
    languageSkills: languageSkills,
    computerSkills: computerSkills
  })), (0, _core.jsx)(_Card["default"], {
    css: styles.card,
    color: "white"
  }, (0, _core.jsx)(_Hours["default"], {
    timeTables: timeTables
  })), (0, _core.jsx)(_Card["default"], {
    css: styles.card,
    color: "white",
    ref: refObserver
  }, isMapInView ? (0, _core.jsx)(_StaticMap["default"], {
    googleMapsApiKey: googleMapsApiKey,
    latitude: latitude,
    longitude: longitude,
    radius: radius
  }) : null)), (0, _core.jsx)(_Flex["default"], {
    css: styles.secondColumn
  }, (0, _core.jsx)(_Card["default"], {
    css: styles.card,
    color: "white"
  }, (0, _core.jsx)(_Description["default"], {
    tasks: tasks,
    profile: profile,
    advertisement: advertisement
  })), (0, _core.jsx)(_Card["default"], {
    css: styles.card,
    color: "white"
  }, (0, _core.jsx)(_Contract["default"], {
    jobStatus: jobStatus
  }))))));
};

__signature__(ResponsiveJobCard, "useTheme{{ breakpoint }}\nuseStyles{styles}\nuseInView{[refObserver, isMapInView]}", function () {
  return [_useTheme3["default"], useStyles, _reactIntersectionObserver.useInView];
});

var _default = ResponsiveJobCard;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/index.tsx");
  reactHotLoader.register(ResponsiveJobCard, "ResponsiveJobCard", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();